import { render, staticRenderFns } from "./ProductTypeOverviewTable.vue?vue&type=template&id=05ef531a"
import script from "./ProductTypeOverviewTable.vue?vue&type=script&lang=js"
export * from "./ProductTypeOverviewTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports